const IADOSReducer = (state = {}, action) => {
    switch (action.type) {
        case "IADOS_LIST_DOCS":
            return Object.assign({}, state, {
                IADOS_ListView: action.data
            });
        case "IADOSAUDIT_DOCS":
            return Object.assign({}, state, {
                Audit_ListView: action.data
            });
        case "SHARE_IADOS_ATTACH_PHOTO":
            return Object.assign({}, state, {
                sharediadosattachphoto: action.data
            });
        case "SHARE_IADOS_ATTACH_CPHOTO":
            return Object.assign({}, state, {
                sharediadosattachcphoto: action.data
            });
        case "SHARE_IADOSDATAS":
            return Object.assign({}, state, {
                sharediadosdata: action.data
            });
        case "ERROR_IADOSFILES":
            return Object.assign({}, state, {
                erroriadospass: action.data
            });
        default:
            return state;
    }
};

export default IADOSReducer;